import { UserServiceService } from "./../services/user-service/user-service.service";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { ReservationService } from "./../services/reservation-service/reservation.service";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "../services/projects/projects.service";

@Component({
  selector: "app-daily-report",
  templateUrl: "./daily-report.component.html",
  styleUrls: ["./daily-report.component.css"],
})
export class DailyReportComponent implements OnInit {
  monthly_sources_residential: any;
  brokers_residential: any;
  monthly_report: any;
  monthly_yearly_report: any;
  daily_residential_reservations: any;
  hold_reports: any;
  eois_reports: any;

  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  view: any;

  projects: any;
  projectsDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  agentsDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  unitTypesDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  filter_form: FormGroup;

  project_id: any;
  source_id: any;
  agent_id: any;
  broker_id: any;
  types: any;

  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));

  allSources;
  allEvents;
  allAgents;
  allBrokers;

  selectedSources: any = [];

  contracts_filter = false;
  sources_filter = false;
  brokers_filter = false;
  hold_filter = false;
  eois_filter = false;

  isLoading = false;

  agent_sales_filter = false;
  agents_sales_projects;
  agents_sales_data;

  agent_activities_filter = false;
  agents_activities_actions;
  agents_activities_data;

  agent_activities_leads_filter = false;
  agents_activities_leads_data;

  // loading alg
  loading_texts = [
    "Initiating Report",
    "Calculate Data",
    "Grouping Results",
    "Loading",
  ];

  loader = {
    index: 0,
    dot: 0,
    maxDot: 3,
    text: this.loading_texts[0],
    interval: null,
  };

  page = 1;

  sourcePage = 1;

  views_conf = {
    filters: false,
    charts: false,
  };

  charts: any = {
    eoi_accumulative: {},
    eoi_daily: {},
    eoi_monthly: {},
    eoi_yearly: {},
    matching: {},
    post_date_analysis: {
      months: {},
      years: {},
    },
  };

  chartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      gridLines: {
        display: false,
      },
    },

    layout: {
      padding: 10,
    },
    elements: {
      line: {
        fill: "origin",
        radius: 5,
        tension: 0.4,
      },
    },
  };

  downloading_export: boolean = false;

  unit_types: any;
  unit_types_filter: boolean = false;

  unit_types_status: any;
  unit_types_status_filter: boolean = false;

  unit_design_types: any;

  project_units_report: any;
  project_units_report_filter: boolean = false;

  eastshire_units_report: any;
  eastshire_units_report_filter: boolean = false;

  season_inventory_report: any;
  season_inventory_report_filter: boolean = false;

  manager_sales_report: any;
  manager_sales_report_filter: boolean = false;

  pc_sales_report: any;
  pc_sales_report_filter: boolean = false;

  overseas_sales_report: any;
  overseas_sales_report_filter: boolean = false;

  channel_sales_report: any;
  channel_sales_report_filter: boolean = false;

  projects_units_yearly_report: any;
  projects_units_yearly_report_filter: boolean = false;

  pc_target_report: any;
  pc_target_report_filter: boolean = false;

  managers_target_report: any;
  managers_target_report_filter: boolean = false;

  years = [
    2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
    2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033,
  ];

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private projectService: ProjectsService,
    private formBuilder: FormBuilder,
    private reservationService: ReservationService,
    private leadsService: LeadsService,
    private userService: UserServiceService
  ) {
    if (this.userData.role == "Sales Director") {
      this.view = "sources";
    } else {
      this.view = "contracts";
    }
    console.log(this.userData);
  }

  ngOnInit() {
    this.getUnitDesignTypes();
    this.createFilterForm();
    this.getAllProjects();
    this.getMonthlyReport();
    this.getDailyReportsResidentialReservations();
    this.getAllAgents();
    this.getAllBrokers();
  }

  getUnitDesignTypes() {
    this.projectService.getUnitDesignTypes().subscribe((res: any) => {
      this.unit_design_types = res.map((type, index) => {
        return {
          name: type,
          id: index,
        };
      });
    });
  }

  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      // from_date: ['moment(new Date()).format("YYYY-MM-DD")'],
      // to_date: [moment(new Date()).format("YYYY-MM-DD")]
      from_date: null,
      to_date: null,
      year: null,
    });
  }

  getAllSources() {
    this.projectService.getAllSources().subscribe((res: any) => {
      this.allSources = res;
      console.log("************sources***********", this.allSources);
    });
  }

  getAllAgents() {
    this.leadsService.getAgents().subscribe((data: any) => {
      this.allAgents = data;
    });
  }

  getAllBrokers() {
    this.userService.getBorkers().subscribe((data: any) => {
      this.allBrokers = data;
      console.log(this.allBrokers);
    });
  }

  get from_date() {
    return this.filter_form.get("from_date").value;
  }

  get to_date() {
    return this.filter_form.get("to_date").value;
  }

  get year() {
    return this.filter_form.get("year").value;
  }
  // get sources_ids() {
  //   return this.filter_form.get("sources_ids").value;
  // }

  getAllProjects() {
    this.projectService.getProjects().subscribe(
      (data: any) => {
        this.projects = data.data;
      },
      (err) => {}
    );
  }

  onItemSelect(item: any) {
    // console.log(item);
    // let ids =
  }

  onProjectSelectionChange() {
    // console.log(this.project_id);
    // if (this.is_filter) {
    //   this.filter();
    // } else {
    let ids = [];
    if (this.project_id) {
      this.project_id.forEach((project) => {
        ids.push(project.id);
      });
    }

    if (ids.length > 0) {
      let projects_ids_string = ids.join(",");
      this.getDailyReportsResidentialReservations(projects_ids_string);
      this.getMonthlyReportResdiential(projects_ids_string);
      this.getMonthlyReport(projects_ids_string);
      this.getMonthlyYearlyReport(projects_ids_string);
      this.getHoldDailyReports(projects_ids_string);
      this.getEoisDailyReports(projects_ids_string);
    } else {
      this.getDailyReportsResidentialReservations();
      this.getMonthlyReportResdiential(this.sourcePage);
      this.getMonthlyReport();
      this.getMonthlyYearlyReport();
      this.getHoldDailyReports();
      this.getEoisDailyReports();
    }
    // }
  }

  onSelectAll(items: any) {}

  filter() {
    // to do filter all reports
    let ids = [];
    let projects_ids_string = "";
    if (this.project_id) {
      this.project_id.forEach((project) => {
        ids.push(project.id);
      });
    }
    if (ids.length > 0) {
      projects_ids_string = ids.join(",");
    }
    console.log("===============================================");
    let sourcesIds = [];
    let sources_ids_string = "";
    if (this.source_id) {
      this.source_id.forEach((source) => {
        sourcesIds.push(source.id);
      });
    }
    if (sourcesIds.length > 0) {
      sources_ids_string = sourcesIds.join(",");
    }
    console.log(
      "======================**=========================",
      sources_ids_string
    );
    let eventsIds = [];
    let events_ids_string = "";
    if (eventsIds.length > 0) {
      events_ids_string = eventsIds.join(",");
    }

    let brokersIds = [];
    let brokers_ids_string = "";
    if (this.broker_id) {
      this.broker_id.forEach((broker) => {
        brokersIds.push(broker.id);
      });
    }
    if (brokersIds.length > 0) {
      brokers_ids_string = brokersIds.join(",");
    }

    let agentsIds = [];
    let agents_ids_string = "";
    if (this.agent_id) {
      this.agent_id.forEach((agent) => {
        agentsIds.push(agent.id);
      });
    }
    if (agentsIds.length > 0) {
      agents_ids_string = agentsIds.join(",");
    }
    console.log("======================**=========================");
    console.log(
      projects_ids_string,
      sources_ids_string,
      this.from_date,
      this.to_date
    );
    let typesNames = [];
    let types_names_string = "";
    console.log(this.types);
    if (this.types) {
      this.types.forEach((type) => {
        typesNames.push(type.name);
      });
    }
    if (typesNames.length > 0) {
      types_names_string = typesNames.join(",");
    }
    if (this.view == "contracts") {
      this.contracts_filter = true;
      this.getDailyReportsResidentialReservations(
        projects_ids_string,
        this.from_date,
        this.to_date
      );
      this.getMonthlyReport(projects_ids_string, this.from_date, this.to_date);
    }
    if (this.view == "months") {
      this.getMonthlyYearlyReport(
        projects_ids_string,
        this.from_date,
        this.to_date
      );
    }
    if (this.view == "sources") {
      this.sources_filter = true;
      this.getMonthlyReportResdiential(
        projects_ids_string,
        this.from_date,
        this.to_date,
        sources_ids_string,
        agents_ids_string
      );
    }
    if (this.view == "brokers") {
      this.brokers_filter = true;
      this.getBrokersResidential(
        projects_ids_string,
        this.from_date,
        this.to_date,
        brokers_ids_string,
        agents_ids_string
      );
    }
    if (this.view == "hold") {
      this.hold_filter = true;
      this.getHoldDailyReports(
        projects_ids_string,
        this.from_date,
        this.to_date
      );
    }
    if (this.view == "eois") {
      this.eois_filter = true;
      this.getEoisDailyReports(
        projects_ids_string,
        this.from_date,
        this.to_date
      );
    }
    if (this.view == "agent_sales") {
      this.manager_sales_report_filter = true;
      this.getSalesAgentsReports(
        projects_ids_string,
        this.from_date,
        this.to_date
      );
    }
    console.log(types_names_string);
    if (this.view == "units_types") {
      this.unit_types_filter = true;
      this.getUnitTypesReports(projects_ids_string, types_names_string);
    }
    if (this.view == "units_types_status") {
      this.unit_types_status_filter = true;
      this.getUnitTypesStatus(projects_ids_string, types_names_string);
    }
    if (this.view == "project_units") {
      this.project_units_report_filter = true;
      this.getProjectUnitsReports(projects_ids_string, types_names_string);
    }
    if (this.view == "eastshire_units") {
      this.eastshire_units_report_filter = true;
      this.getEastshireUnitsReports(projects_ids_string, types_names_string);
    }
    if (this.view == "season_inventory") {
      this.season_inventory_report_filter = true;
      this.getSeasonInventoryReports(projects_ids_string, types_names_string);
    }
    if (this.view == "manager_sales_report") {
      this.manager_sales_report_filter = true;
      this.getManagerSalesReports(projects_ids_string, types_names_string);
    }
    if (this.view == "pc_sales_report") {
      this.pc_sales_report_filter = true;
      this.getPCSalesReports(projects_ids_string, types_names_string);
    }
    if (this.view == "overseas_sales_report") {
      this.overseas_sales_report_filter = true;
      this.getOverseasSalesReports(projects_ids_string, types_names_string);
    }
    if (this.view == "channel_sales_report") {
      this.channel_sales_report_filter = true;
      this.getChannelSalesReports(projects_ids_string, types_names_string);
    }
    if (this.view == "projects_units_yearly_report") {
      this.projects_units_yearly_report_filter = true;
      this.getProjectsUnitsYearlyReports(
        projects_ids_string,
        types_names_string
      );
    }
    if (this.view == "pc_target_report") {
      this.pc_target_report_filter = true;
      this.getPCTargetReports(
        projects_ids_string,
        this.year,
        brokers_ids_string
      );
    }
    if (this.view == "managers_target_report") {
      this.managers_target_report_filter = true;
      this.getManagersTargetReports(
        projects_ids_string,
        this.year,
        brokers_ids_string
      );
    }
    // TODO filters sales agents
  }

  filterReports() {}

  reset() {
    this.filter_form.reset();
    // this.getDailyReportsResidentialReservations();
    // this.getMonthlyReportResdiential();
    // this.getMonthlyReport();
    // this.getMonthlyYearlyReport();
    // this.getHoldDailyReports();
    // this.getEoisDailyReports();
    this.project_id = "";
    this.source_id = "";
    this.agent_id = "";
    this.broker_id = "";
    // this.is_filter = false;
    this.contracts_filter = false;
    this.sources_filter = false;
    this.hold_filter = false;
    this.eois_filter = false;
    this.agent_sales_filter = false;
    this.unit_types_filter = false;
    this.unit_types_status_filter = false;
    this.project_units_report_filter = false;
    this.eastshire_units_report_filter = false;
    this.season_inventory_report_filter = false;
    this.manager_sales_report_filter = false;
    this.pc_sales_report_filter = false;
    this.overseas_sales_report_filter = false;
    this.channel_sales_report_filter = false;
    this.projects_units_yearly_report_filter = false;
    this.pc_target_report_filter = false;
    this.managers_target_report_filter = false;
    this.setView(this.view);
  }

  getMonthlyReportResdiential(
    page,
    project_ids?,
    from_date?,
    to_date?,
    sources_ids?,
    agent_ids?,
    is_export?
  ) {
    console.log(is_export);
    if (this.userData.role != "Moderator") {
      if (is_export) {
        this.downloading_export = true;
      } else {
        this.isLoading = true;
      }
      this.slimLoadingBarService.start();
      this.projectService
        .getDailyReportyMonthly(
          page,
          project_ids,
          from_date,
          to_date,
          sources_ids,
          agent_ids,
          is_export
        )
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.downloading_export = false;
            if (is_export) {
              window.open(res);
            } else {
              this.monthly_sources_residential = res;
            }
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.isLoading = false;
            this.downloading_export = false;
            console.log(err);
            this.slimLoadingBarService.reset();
          }
        );
    }
  }

  getBrokersResidential(
    page,
    project_ids?,
    from_date?,
    to_date?,
    broker_ids?,
    agent_ids?,
    is_export?
  ) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.slimLoadingBarService.start();
    this.projectService
      .getBrokersResidential(
        page,
        project_ids,
        from_date,
        to_date,
        broker_ids,
        agent_ids,
        is_export
      )
      .subscribe(
        (res: any) => {
          this.downloading_export = false;
          this.isLoading = false;
          if (is_export) {
            window.open(res);
          } else {
            this.brokers_residential = res;
          }
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.downloading_export = false;
          this.isLoading = false;
          this.slimLoadingBarService.reset();
        }
      );
  }

  getMonthlyReport(project_ids?, from_date?, to_date?) {
    this.isLoading = true;
    this.projectService
      .getMonthlyReport(project_ids, from_date, to_date)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          this.monthly_report = res;
        },
        (err) => {
          this.isLoading = false;
          console.log(err);
        }
      );
  }

  getMonthlyYearlyReport(project_ids?, from_date?, to_date?, is_export?) {
    if (is_export) {
      this.downloading_export = true;
    } else {
      this.isLoading = true;
    }
    if (this.userData.role != "Moderator") {
      this.projectService
        .getMonthlyYearlyReport(project_ids, from_date, to_date, is_export)
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.downloading_export = false;
            if (is_export) {
              window.open(res);
            } else {
              this.monthly_yearly_report = res;
            }
          },
          (err) => {
            this.isLoading = false;
            this.downloading_export = false;
            console.log(err);
          }
        );
    }
  }

  getSalesAgentsReports(
    project_ids?,
    from_date?,
    to_date?,
    agent?,
    is_export?
  ) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getAgentSalesReports(project_ids, from_date, to_date, agent, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.agents_sales_data = res;
            if (res.data && res.data.length > 0) {
              this.agents_sales_projects = res.data[0].projects;
            }
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getActivitiesAgentsReports(
    project_ids?,
    from_date?,
    to_date?,
    agent_ids?,
    is_export?
  ) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getActivitiesAgentsReports(
        project_ids,
        from_date,
        to_date,
        agent_ids,
        is_export
      )
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.agents_activities_data = res;
            if (res.data && res.data.length > 0) {
              this.agents_activities_actions = res.data[0].actions;
            }
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getActivitiesLeadsAgentsReports(
    project_ids?,
    from_date?,
    to_date?,
    agent_ids?,
    is_export?
  ) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getActivitiesLeadsAgentsReports(
        project_ids,
        from_date,
        to_date,
        agent_ids,
        is_export
      )
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.agents_activities_leads_data = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getDailyReportsResidentialReservations(
    project_ids?,
    from_date?,
    to_date?,
    is_export?
  ) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getDailyReportsResidentialReservations(
        project_ids,
        from_date,
        to_date,
        is_export
      )
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.daily_residential_reservations = res;
            this.charts.daily_reservations = {
              labels: [],
              datasets: [],
            };
            this.charts.daily_reservations.labels = ["Daily"];
            this.charts.daily_reservations.datasets = [
              {
                data: [res.daily.cancelledDeal.value],
                label: ["Cancelled Deal"],
              },
              {
                data: [res.daily.doneDeal.value],
                label: ["Done Deal"],
              },
              {
                data: [res.daily.pendingContract.value],
                label: ["Pending Deals"],
              },
              {
                data: res.daily.total ? [res.daily.total.value] : [],
                label: ["Total Deal"],
              },
            ];

            this.charts.monthly_reservations = {
              labels: [],
              datasets: [],
            };
            this.charts.monthly_reservations.labels = ["Monthly"];
            this.charts.monthly_reservations.datasets = [
              {
                data: [res.monthly.cancelledDeal.value],
                label: ["Cancelled Deal"],
              },
              {
                data: [res.monthly.doneDeal.value],
                label: ["Done Deal"],
              },
              {
                data: [res.monthly.pendingContract.value],
                label: ["Pending Deals"],
              },
              {
                data: res.monthly.total ? [res.monthly.total.value] : [],
                label: ["Total Deal"],
              },
            ];

            this.charts.yearly_reservations = {
              labels: [],
              datasets: [],
            };
            this.charts.yearly_reservations.labels = ["Yearly"];
            this.charts.yearly_reservations.datasets = [
              {
                data: [res.yearly.cancelledDeal.value],
                label: ["Cancelled Deal"],
              },
              {
                data: [res.yearly.doneDeal.value],
                label: ["Done Deal"],
              },
              {
                data: [res.yearly.pendingContract.value],
                label: ["Pending Deals"],
              },
              {
                data: res.yearly.total ? [res.yearly.total.value] : [],
                label: ["Total Deal"],
              },
            ];

            this.charts.accumulative_reservations = {
              labels: [],
              datasets: [],
            };
            this.charts.accumulative_reservations.labels = ["Accumulative"];
            this.charts.accumulative_reservations.datasets = [
              {
                data: [res.accumulative.cancelledDeal.value],
                label: ["Cancelled Deal"],
              },
              {
                data: [res.accumulative.doneDeal.value],
                label: ["Done Deal"],
              },
              {
                data: [res.accumulative.pendingContract.value],
                label: ["Pending Deals"],
              },
              {
                data: res.accumulative.total
                  ? [res.accumulative.total.value]
                  : [],
                label: ["Total Deal"],
              },
            ];
          }
          this.isLoading = false;
          this.downloading_export = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getHoldDailyReports(project_ids?, from_date?, to_date?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getHoldDailyReports(project_ids, from_date, to_date, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.hold_reports = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getEoisDailyReports(project_ids?, from_date?, to_date?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getEoisDailyReports(project_ids, from_date, to_date, is_export)
      .subscribe(
        (res: any) => {
          this.downloading_export = false;
          this.isLoading = false;
          if (is_export) {
            window.open(res);
          } else {
            this.eois_reports = res;
            this.charts.eoi_accumulative = {
              labels: [],
              datasets: [],
            };

            this.charts.eoi_accumulative.labels = ["Accumulative"];
            this.charts.eoi_accumulative.datasets = [
              {
                data: [res.accumulative.approved.value],
                label: ["approved"],
              },
              {
                data: [res.accumulative.cancelled.value],
                label: ["cancelled"],
              },
              {
                data: [res.accumulative.deposited.value],
                label: ["deposited"],
              },
              {
                data: [res.accumulative.pending.value],
                label: ["pending"],
              },
              {
                data: [res.accumulative.refunded.value],
                label: ["refunded"],
              },
            ];
            this.charts.eoi_daily.labels = ["Daily"];
            this.charts.eoi_daily.datasets = [
              {
                data: [res.daily.approved.value],
                label: ["approved"],
              },
              {
                data: [res.daily.cancelled.value],
                label: ["cancelled"],
              },
              {
                data: [res.daily.deposited.value],
                label: ["deposited"],
              },
              {
                data: [res.daily.pending.value],
                label: ["pending"],
              },
              {
                data: [res.daily.refunded.value],
                label: ["refunded"],
              },
            ];
            this.charts.eoi_monthly.labels = ["Monthly"];
            this.charts.eoi_monthly.datasets = [
              {
                data: [res.monthly.approved.value],
                label: ["approved"],
              },
              {
                data: [res.monthly.cancelled.value],
                label: ["cancelled"],
              },
              {
                data: [res.monthly.deposited.value],
                label: ["deposited"],
              },
              {
                data: [res.monthly.pending.value],
                label: ["pending"],
              },
              {
                data: [res.monthly.refunded.value],
                label: ["refunded"],
              },
            ];
            this.charts.eoi_yearly.labels = ["Yearly"];
            this.charts.eoi_yearly.datasets = [
              {
                data: [res.yearly.approved.value],
                label: ["approved"],
              },
              {
                data: [res.yearly.cancelled.value],
                label: ["cancelled"],
              },
              {
                data: [res.yearly.deposited.value],
                label: ["deposited"],
              },
              {
                data: [res.yearly.pending.value],
                label: ["pending"],
              },
              {
                data: [res.yearly.refunded.value],
                label: ["refunded"],
              },
            ];
            console.log(this.charts);
          }
        },
        (err) => {
          this.downloading_export = false;
          this.isLoading = false;
          console.log(err);
        }
      );
  }

  getUnitTypesReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getUnitTypesReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.unit_types = res;
          }
          console.log(this.unit_types);
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getUnitTypesStatus(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getUnitTypesStatus(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.unit_types_status = res;
          }
          console.log(this.unit_types_status);
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getProjectUnitsReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getProjectUnitsReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.project_units_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getEastshireUnitsReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getEastshireUnitsReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.eastshire_units_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getSeasonInventoryReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getSeasonInventoryReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.season_inventory_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getManagerSalesReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getManagerSalesReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.manager_sales_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getPCSalesReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getPCSalesReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.pc_sales_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getOverseasSalesReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getOverSalesReport(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.overseas_sales_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getChannelSalesReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getChannelSalesReport(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.channel_sales_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getProjectsUnitsYearlyReports(project_ids?, types_names_string?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getProjectsUnitsYearlyReports(project_ids, types_names_string, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.projects_units_yearly_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getPCTargetReports(project_ids?, year?, agent_ids?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getPCTargetReports(project_ids, year, agent_ids, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.pc_target_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  getManagersTargetReports(project_ids?, year?, agent_ids?, is_export?) {
    if (is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService
      .getManagersTargetReports(project_ids, year, agent_ids, is_export)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res);
          } else {
            this.managers_target_report = res;
          }
          this.downloading_export = false;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
          this.isLoading = false;
        }
      );
  }

  setView(tab: String) {
    this.views_conf.filters = false;
    this.views_conf.charts = null;
    this.view = tab;
    if (tab == "months") {
      this.getMonthlyYearlyReport();
    }
    if (tab == "contracts") {
      this.getDailyReportsResidentialReservations();
      this.views_conf.charts = false;
    }
    if (tab == "sources") {
      this.getMonthlyReportResdiential(this.sourcePage);
      this.getAllSources();
    }
    if (tab == "brokers") {
      this.getBrokersResidential(this.page);
      // this.getAllSources();
    }
    if (tab == "hold") {
      this.getHoldDailyReports();
    }
    if (tab == "eois") {
      this.views_conf.charts = false;
      this.getEoisDailyReports();
    }
    if (tab == "agent_sales") {
      this.getSalesAgentsReports();
    }
    if (tab == "agent_activities") {
      this.getActivitiesAgentsReports();
      this.getAllSources();
    }
    if (tab == "agent_activities_leads") {
      this.getActivitiesLeadsAgentsReports();
    }
    if (tab == "units_types") {
      this.getUnitTypesReports();
    }
    if (tab == "units_types_status") {
      this.getUnitTypesStatus();
    }
    if (tab == "project_units") {
      this.getProjectUnitsReports();
    }
    if (tab == "eastshire_units") {
      this.getEastshireUnitsReports();
    }
    if (tab == "season_inventory") {
      this.getSeasonInventoryReports();
    }
    if (tab == "manager_sales_report") {
      this.getManagerSalesReports();
    }
    if (tab == "pc_sales_report") {
      this.getPCSalesReports();
    }
    if (tab == "overseas_sales_report") {
      this.getOverseasSalesReports();
    }
    if (tab == "channel_sales_report") {
      this.getChannelSalesReports();
    }
    if (tab == "projects_units_yearly_report") {
      this.getProjectsUnitsYearlyReports();
    }
    if (tab == "pc_target_report") {
      this.getPCTargetReports();
    }
    if (tab == "managers_target_report") {
      this.getManagersTargetReports();
    }
  }

  isHelpDeskUser() {
    // return this.userData.role == "Helpdesk Supervisor" || this.userData.role == "Helpdesk Agent"
    return this.userData.role == "Helpdesk Agent";
  }

  onAgentsSelectionChange() {}

  enableLoading() {
    this.isLoading = true;

    this.loader.index = 0;
    this.loader.dot = 0;
    this.loader.text = this.loading_texts[0];

    this.loader.interval = setInterval(() => {
      if (!this.isLoading) return this.disableLoading();

      if (this.loader.dot < this.loader.maxDot) {
        this.loader.dot++;
        this.loader.text += ".";
      } else {
        this.loader.dot = 0;
        if (this.loader.index < this.loading_texts.length - 1) {
          this.loader.index++;
        } else {
          this.loader.index = 0;
        }
        this.loader.text = this.loading_texts[this.loader.index];
      }
    }, 1000);
  }

  disableLoading() {
    this.isLoading = false;
    clearInterval(this.loader.interval);
  }

  pageChange(ev) {
    this.getBrokersResidential(ev);
  }

  sourcePageChange(ev) {
    this.getMonthlyReportResdiential(ev);
  }

  downloadReport() {
    console.log(this.view);
    let ids = [];
    if (this.project_id) {
      this.project_id.forEach((project) => {
        ids.push(project.id);
      });
    }
    let projects_ids_string = ids.join(",");
    let sourcesIds = [];
    let sources_ids_string = "";
    if (this.source_id) {
      this.source_id.forEach((source) => {
        sourcesIds.push(source.id);
      });
    }
    if (sourcesIds.length > 0) {
      sources_ids_string = sourcesIds.join(",");
    }
    let eventsIds = [];
    let events_ids_string = "";
    if (eventsIds.length > 0) {
      events_ids_string = eventsIds.join(",");
    }

    let brokersIds = [];
    let brokers_ids_string = "";
    if (this.broker_id) {
      this.broker_id.forEach((broker) => {
        brokersIds.push(broker.id);
      });
    }
    if (brokersIds.length > 0) {
      brokers_ids_string = brokersIds.join(",");
    }

    let agentsIds = [];
    let agents_ids_string = "";
    if (this.agent_id) {
      this.agent_id.forEach((agent) => {
        agentsIds.push(agent.id);
      });
    }
    if (agentsIds.length > 0) {
      agents_ids_string = agentsIds.join(",");
    }
    let typesNames = [];
    let types_names_string = "";
    if (this.types) {
      this.types.forEach((type) => {
        typesNames.push(type.name);
      });
    }
    if (types_names_string.length > 0) {
      types_names_string = typesNames.join(",");
    }
    switch (this.view) {
      case "months":
      case "contracts":
        this.getDailyReportsResidentialReservations(
          projects_ids_string,
          this.from_date,
          this.to_date,
          true
        );
        break;
      case "sources":
        this.getMonthlyReportResdiential(
          this.sourcePage,
          projects_ids_string,
          this.from_date,
          this.to_date,
          sources_ids_string,
          agents_ids_string,
          true
        );
        break;
      case "brokers":
        this.getBrokersResidential(
          this.page,
          projects_ids_string,
          this.from_date,
          this.to_date,
          brokers_ids_string,
          agents_ids_string,
          true
        );
        break;
      case "hold":
        this.getHoldDailyReports(
          projects_ids_string,
          this.from_date,
          this.to_date,
          true
        );
        break;
      case "eois":
        this.getEoisDailyReports(
          projects_ids_string,
          this.from_date,
          this.to_date,
          true
        );
        break;
      case "agent_sales":
        this.getSalesAgentsReports(
          projects_ids_string,
          this.from_date,
          this.to_date,
          agents_ids_string,
          true
        );
        break;
      case "agent_activities":
        this.getActivitiesAgentsReports(
          projects_ids_string,
          this.from_date,
          this.to_date,
          agents_ids_string,
          true
        );
        break;
      case "agent_activities_leads":
        this.getActivitiesLeadsAgentsReports(
          projects_ids_string,
          this.from_date,
          this.to_date,
          agents_ids_string,
          true
        );
        break;
      case "units_types":
        this.getUnitTypesReports(projects_ids_string, types_names_string, true);
        break;
      case "units_types_status":
        this.getUnitTypesStatus(projects_ids_string, types_names_string, true);
        break;
      case "project_units":
        this.getProjectUnitsReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "eastshire_units":
        this.getEastshireUnitsReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "season_inventory":
        this.getSeasonInventoryReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "manager_sales_report":
        this.getManagerSalesReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "pc_sales_report":
        this.getPCSalesReports(projects_ids_string, types_names_string, true);
        break;
      case "overseas_sales_report":
        this.getOverseasSalesReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "channel_sales_report":
        this.getChannelSalesReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "projects_units_yearly_report":
        this.getProjectsUnitsYearlyReports(
          projects_ids_string,
          types_names_string,
          true
        );
        break;
      case "pc_target_report":
        this.getPCTargetReports(true);
        break;
      case "managers_target_report":
        this.getManagersTargetReports(true);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/daily-report/daily-report.component.ts